import { ColumnType } from 'antd/lib/table'
import { SortOptions } from '../../CIMSColumn/types/sort'
import { alphabeticalSort } from '@cims-online/shared'

export function setSortOptions<T extends object>(
  column: ColumnType<T>,
  sort: SortOptions<T>
) {
  column.sorter = {
    compare:
      sort.with === 'callback' ? sort.onCompare : alphabeticalSort(sort.key),
    multiple:
      typeof sort.priority === 'number'
        ? 1 / (Math.abs(sort.priority) + 1)
        : undefined,
  }
  column.defaultSortOrder = sort.default
  column.sortDirections = sort.directions
}
